import { AnyAction } from 'redux';
import { App, TkvV2Vorbelegungdaten } from '@ps20-frontend/frontend-models';
import { BreedSelectionType } from '@ps20/bff-models';
import { isNeugeschaeft } from '@ps20-frontend/shop-integration-redux';
import { TkvActions } from '../tkvActions';
import { IAppState } from '../appState';

export interface Vorbelegungen {
  adresseImmobilieVorbelegt: boolean;
  versicherungsnehmerVorbelegt: boolean;
  disabledFields?: DisabledFields;
  breedSelectionType?: BreedSelectionType;
  breedMappingNotificationRequired?: boolean;
  hasAssistenzhund?: boolean;
  isVnWechsel?: boolean;
}

export interface DisabledFields {
  geburtsdatum: boolean;
  tierKastriert: boolean;
  tierart: boolean;
  geschlecht: boolean;
  rasse: boolean;
  breedSelectionRadio: boolean;
  dogSize: boolean;
  dogMotherBreed: boolean;
  tiername: boolean;
}

function isTiernameValid(tiername: string | undefined, state: IAppState): boolean {
  if (!tiername) {
    return false;
  }
  const tierNameRegex = state.transientState?.regexps?.TIERNAME;
  if (!tierNameRegex) {
    return false;
  }
  return new RegExp(tierNameRegex).test(tiername);
}

export const vorbelegungenReducer = function (
  sectionState: Vorbelegungen = null,
  action: AnyAction,
  state: IAppState,
): Vorbelegungen {
  if (action.type === TkvActions.VORBELEGUNG_FOR_TKV_ERSATZ_REQUESTED) {
    const actionPayload: TkvV2Vorbelegungdaten = action.payload;
    const isErsatz = !isNeugeschaeft(state.vertragsoptionen);
    if (actionPayload.forApp === App.TKV_V2 && actionPayload.angebotsId === state.angebotsId) {
      const breedSelectionType = actionPayload.breedSelectionType;

      return {
        ...sectionState,
        adresseImmobilieVorbelegt: true,
        breedSelectionType,
        breedMappingNotificationRequired: Boolean(actionPayload.breedMappingNotificationRequired),
        hasAssistenzhund: Boolean(actionPayload.hasAssistenzhund),
        isVnWechsel: Boolean(actionPayload.isVnWechsel),
        disabledFields: {
          geburtsdatum: Boolean(actionPayload.geburtsdatumTier && isErsatz),
          tierKastriert: false,
          tierart: Boolean(actionPayload.tierart && isErsatz),
          geschlecht: Boolean(actionPayload.tiergeschlecht && isErsatz),
          rasse: Boolean(actionPayload.tierrasse && isErsatz),
          breedSelectionRadio: Boolean(breedSelectionType && isErsatz),
          dogSize: Boolean(
            (breedSelectionType === BreedSelectionType.UNKNOWN_HEIGHT_SMALL ||
              breedSelectionType === BreedSelectionType.UNKNOWN_HEIGHT_LARGE) &&
              isErsatz
          ),
          dogMotherBreed: Boolean(breedSelectionType === BreedSelectionType.MIX && isErsatz),
          tiername: Boolean(isTiernameValid(actionPayload.tiername, state) && isErsatz && !actionPayload.isVnWechsel),
        },
      };
    }
    return sectionState;
  }
  return sectionState;
};
